module.exports = __webpack_public_path__ + "static/media/VP_3_GRAPHIC.fa2b2ca0.svg";